"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _queryString = _interopRequireDefault(require("query-string"));
function _default() {
  var defaultLanguage = 'tr';
  var parsedLocation = _queryString.default.parse(window.location.search);
  var language = parsedLocation['language'] || defaultLanguage;
  return language;
}